import React from "react";
import { m } from "framer-motion";
import Facebook from "@/icons/facebook";
import Linkedin from "@/icons/linkedin";
import Twitter from "@/icons/twitter";
import Whatsapp from "@/icons/whatsapp";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
} from "next-share";

export default function SocialShare({
  url,
  slug = "#",
  title = "Share:",
  postTile = "title",
}) {
  const productUrl = url + slug;

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.2,
      },
    },
  };

  const socialIconClass =
    "w-5 hover:text-darkBrown transition-all duration-200 ease cursor-pointer";

  return (
    <m.div
      initial={{ opacity: 0, x: 20 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      className={`flex flex-row justify-start items-center relative gap-4 w-fit mt-6`}
    >
      <p className={`text-brown text-center font-semibold`}>{title}</p>
      <div
        variants={container}
        initial="hidden"
        animate="show"
        className={`w-full grid grid-cols-4 auto-rows-auto md:gap-4 gap-4`}
      >
        <FacebookShareButton
          url={productUrl}
          quote={`Check out *${postTile}* on Hypefly India —`}
          hashtags={"#hypefly"}
        >
          <Facebook className={socialIconClass} />
        </FacebookShareButton>

        <TwitterShareButton
          url={productUrl}
          title={`Check out *${postTile}* on Hypefly India —`}
          hashtags={["#hypefly"]}
        >
          <Twitter className={socialIconClass} />
        </TwitterShareButton>

        <WhatsappShareButton
          url={`${productUrl}`}
          title={`Check out *${postTile}* on Hypefly India —`}
        >
          <Whatsapp className={socialIconClass} />
        </WhatsappShareButton>

        <LinkedinShareButton url={productUrl}>
          <Linkedin className={socialIconClass} />
        </LinkedinShareButton>
      </div>
    </m.div>
  );
}
